// // hooks/useFutures.js

// import { useState, useCallback } from "react";

// const BASE_URL = process.env.REACT_APP_BASE_URL_URL;

// const useFutures = () => {
//   const [futuresData, setFuturesData] = useState(null);
//   const [futuresLoading, setFuturesLoading] = useState(false);
//   const [futuresError, setFuturesError] = useState(null);

//   // GET /api/fno/futures/:securityId
//   const getFutures = useCallback(async (securityId) => {
//     if (!securityId) return null;

//     setFuturesLoading(true);
//     setFuturesError(null);

//     try {
//       const res = await fetch(`${BASE_URL}/api/fno/futures/${securityId}`);
//       const json = await res.json();

//       if (json.success) {
//         setFuturesData(json);
//         return json;
//       } else {
//         setFuturesError(json.message || "Failed to fetch futures");
//         return null;
//       }
//     } catch (err) {
//       console.error("useFutures error:", err);
//       setFuturesError("Failed to fetch futures data");
//       return null;
//     } finally {
//       setFuturesLoading(false);
//     }
//   }, []);

//   // GET /api/fno/futures/expiry/:symbol
//   const getFuturesExpiry = useCallback(async (symbol) => {
//     if (!symbol) return [];

//     try {
//       const res = await fetch(`${BASE_URL}/api/fno/futures/expiry/${symbol}`);
//       const json = await res.json();
//       return json.success ? json.expiries : [];
//     } catch (err) {
//       console.error("getFuturesExpiry error:", err);
//       return [];
//     }
//   }, []);

//   const resetFutures = useCallback(() => {
//     setFuturesData(null);
//     setFuturesError(null);
//     setFuturesLoading(false);
//   }, []);

//   return {
//     futuresData,
//     futuresLoading,
//     futuresError,
//     getFutures,
//     getFuturesExpiry,
//     resetFutures,
//   };
// };

// export default useFutures;
// hooks/useFutures.js

// hooks/useFutures.js

import { useState, useCallback, useEffect, useRef } from "react";

const BASE_URL =
  process.env.REACT_APP_LIVE_URL || process.env.REACT_APP_BASE_URL_URL;

const isMarketOpen = () => {
  const now = new Date();
  const ist = new Date(
    now.toLocaleString("en-US", { timeZone: "Asia/Kolkata" }),
  );
  const day = ist.getDay();
  const mins = ist.getHours() * 60 + ist.getMinutes();
  return day >= 1 && day <= 5 && mins >= 540 && mins <= 945;
};

const useFutures = () => {
  const [futuresData, setFuturesData] = useState(null);
  const [futuresLoading, setFuturesLoading] = useState(false);
  const [futuresError, setFuturesError] = useState(null);
  const pollingRef = useRef(null);
  const securityIdRef = useRef(null);

  // ─── Fetch futures data ───
  const getFutures = useCallback(async (securityId, options = {}) => {
    if (!securityId) return null;

    securityIdRef.current = securityId;

    // silent = true → don't show loading spinner (for auto-refresh)
    if (!options.silent) {
      setFuturesLoading(true);
    }
    setFuturesError(null);

    try {
      const typeParam = options.type ? `?type=${options.type}` : "";

      const res = await fetch(
        `${BASE_URL}/api/fno/futures/${securityId}/${typeParam}`,
      );
      const json = await res.json();

      if (json.success) {
        setFuturesData(json);
        return json;
      } else {
        setFuturesError(json.message || "Failed to fetch futures");
        return null;
      }
    } catch (err) {
      console.error("useFutures error:", err);
      if (!options.silent) {
        setFuturesError("Failed to fetch futures data");
      }
      return null;
    } finally {
      if (!options.silent) {
        setFuturesLoading(false);
      }
    }
  }, []);

  // ─── Auto-refresh every 30s during market hours ───
  const startPolling = useCallback(
    (securityId) => {
      // Clear existing
      if (pollingRef.current) {
        clearInterval(pollingRef.current);
      }

      if (!isMarketOpen()) return;

      pollingRef.current = setInterval(() => {
        if (!isMarketOpen()) {
          clearInterval(pollingRef.current);
          pollingRef.current = null;
          return;
        }
        getFutures(securityId, { silent: true });
      }, 30000); // 30 seconds
    },
    [getFutures],
  );

  const stopPolling = useCallback(() => {
    if (pollingRef.current) {
      clearInterval(pollingRef.current);
      pollingRef.current = null;
    }
  }, []);

  // ─── Expiry list ───
  const getFuturesExpiry = useCallback(async (symbol) => {
    if (!symbol) return [];
    try {
      const res = await fetch(`${BASE_URL}/api/fno/futures/expiry/${symbol}`);
      const json = await res.json();
      return json.success ? json.expiries : [];
    } catch (err) {
      return [];
    }
  }, []);

  // ─── Reset ───
  const resetFutures = useCallback(() => {
    setFuturesData(null);
    setFuturesError(null);
    setFuturesLoading(false);
    stopPolling();
  }, [stopPolling]);

  // Cleanup on unmount
  useEffect(() => {
    return () => stopPolling();
  }, [stopPolling]);

  return {
    futuresData,
    futuresLoading,
    futuresError,
    getFutures,
    startPolling,
    stopPolling,
    getFuturesExpiry,
    resetFutures,
  };
};

export default useFutures;
